import { css } from '@emotion/core';

import { Theme } from 'src/design-system/theme';

import type { Props } from './ServerStatusIcon';

const container =
  ({ marginBottom = '0', marginRight = '0' }: Props) =>
  (theme: Theme) =>
    css`
      margin-bottom: ${theme.margins[marginBottom]}px;
      margin-right: ${theme.margins[marginRight]}px;
    `;

export const style = { container };
